"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeEmptyValues = void 0;
const removeEmptyValues = (object) => {
    return Object.entries(object)
        .filter(([_, v]) => v != null)
        .reduce((acc, [k, v]) => (Object.assign(Object.assign({}, acc), { [k]: v })), {});
};
exports.removeEmptyValues = removeEmptyValues;
//# sourceMappingURL=removeEmpty.js.map